export const SELECT_HABILITADO_DESHABILITADO = [
    {
        value: 0,
        label: 'status_disabled',
    },
    {
        value: 1,
        label: 'status_enabled',
    },
];